import axios, { AxiosError, AxiosResponse } from "axios";
import $ from "jquery";
import iNotPaieStorageKeys, { LocalStorageService } from "../../components/Controls/LocalStorageService";
import { AbsenceClotureCreationContratDto } from "../../dto/GenApi.iNotPaie.Dto/AbsenceClotureCreationContratDto";
import { AbsenceSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { AbsenceSalarieRangeDto } from "../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieRangeDto";
import { ActiviteDto } from "../../dto/GenApi.iNotPaie.Dto/ActiviteDto";
import { ActualiteDto } from "../../dto/GenApi.iNotPaie.Dto/ActualiteDto";
import { AideEnLigneDto } from "../../dto/GenApi.iNotPaie.Dto/AideEnLigneDto";
import { AlerteDto } from "../../dto/GenApi.iNotPaie.Dto/AlerteDto";
import { AmorcageContratTauxPASDto } from "../../dto/GenApi.iNotPaie.Dto/AmorcageContratTauxPASDto";
import { AttestationCrpcenDto } from "../../dto/GenApi.iNotPaie.Dto/AttestationCrpcenDto";
import { BulletinHeaderDto } from "../../dto/GenApi.iNotPaie.Dto/BulletinHeaderDto";
import { CalculPaieArretSurImageDto } from "../../dto/GenApi.iNotPaie.Dto/CalculPaieArretSurImageDto";
import { CodeSstDto } from "../../dto/GenApi.iNotPaie.Dto/CodeSstDto";
import { CodeUrssafDto } from "../../dto/GenApi.iNotPaie.Dto/CodeUrssafDto";
import { CommandeActionDocumentsGedDto } from "../../dto/GenApi.iNotPaie.Dto/CommandeActionDocumentsGedDto";
import { CommandeActionDossiersGedDto } from "../../dto/GenApi.iNotPaie.Dto/CommandeActionDossiersGedDto";
import { CommandeChangementEtatAbsenceDto } from "../../dto/GenApi.iNotPaie.Dto/CommandeChangementEtatAbsenceDto";
import { CommandeEditionListeSalariesDto } from "../../dto/GenApi.iNotPaie.Dto/CommandeEditionListeSalariesDto";
import { CommandeEnregistrementAbsenceDto } from "../../dto/GenApi.iNotPaie.Dto/CommandeEnregistrementAbsenceDto";
import { CommandeGetAbsenceCollectiveDto } from "../../dto/GenApi.iNotPaie.Dto/CommandeGetAbsenceCollectiveDto";
import { CommandeTelechargementArchive } from "../../dto/GenApi.iNotPaie.Dto/CommandeTelechargementArchive";
import { CommuneDto } from "../../dto/GenApi.iNotPaie.Dto/CommuneDto";
import { ConfigurationEtudeDto } from "../../dto/GenApi.iNotPaie.Dto/ConfigurationEtudeDto";
import { CongeDto } from "../../dto/GenApi.iNotPaie.Dto/CongeDto";
import { CongesSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/CongesSalarieDto";
import { ContratACalculerDto } from "../../dto/GenApi.iNotPaie.Dto/ContratACalculerDto";
import { ContratAEditerDto } from "../../dto/GenApi.iNotPaie.Dto/ContratAEditerDto";
import { ContratAutoFromDsnDto } from "../../dto/GenApi.iNotPaie.Dto/ContratAutoFromDsnDto";
import { ContratElementVariableDto } from "../../dto/GenApi.iNotPaie.Dto/ContratElementVariableDto";
import { ContratSalarieNameDto } from "../../dto/GenApi.iNotPaie.Dto/ContratSalarieNameDto";
import { ControleFichierCsvDto } from "../../dto/GenApi.iNotPaie.Dto/ControleFichierCsvDto";
import { DeclarationOethCalculeeDto } from "../../dto/GenApi.iNotPaie.Dto/DeclarationOethCalculeeDto";
import { DeclarationOethDto } from "../../dto/GenApi.iNotPaie.Dto/DeclarationOethDto";
import { DemandeCalculPaieDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeCalculPaieDto";
import { DemandeCloturePaieDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeCloturePaieDto";
import { DemandeDpaeDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeDpaeDto";
import { DemandeEditionsPaieDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeEditionsPaieDto";
import { DemandeEditionsPaieParSalariesDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeEditionsPaieParSalariesDto";
import { DemandeEditionTableauDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeEditionTableauDto";
import { DemandeFichierVirementsSepaDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeFichierVirementsSepaDto";
import { DemandeImportTopazeDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeImportTopazeDto";
import { DemandeParamTransfertDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeParamTransfertDto";
import { DemandeRecuperationAbsencesFuturesDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeRecuperationAbsencesFuturesDto";
import { DemandeTransfertAbsenceDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeTransfertAbsenceDto";
import { DocumentGedDto } from "../../dto/GenApi.iNotPaie.Dto/DocumentGedDto";
import { DocumentInfoDto } from "../../dto/GenApi.iNotPaie.Dto/DocumentInfoDto";
import { DocumentsArchiveDto } from "../../dto/GenApi.iNotPaie.Dto/DocumentsArchiveDto";
import { DossierDto } from "../../dto/GenApi.iNotPaie.Dto/DossierDto";
import { DossierGedDto } from "../../dto/GenApi.iNotPaie.Dto/DossierGedDto";
import { DsnCompteRenduDto } from "../../dto/GenApi.iNotPaie.Dto/DsnCompteRenduDto";
import { DsnDeclarationDetailleeDto } from "../../dto/GenApi.iNotPaie.Dto/DsnDeclarationDetailleeDto";
import { DsnFilterParametersDto } from "../../dto/GenApi.iNotPaie.Dto/DsnFilterParametersDto";
import { DsnHeaderDto } from "../../dto/GenApi.iNotPaie.Dto/DsnHeaderDto";
import { DsnManuelleDto } from "../../dto/GenApi.iNotPaie.Dto/DsnManuelleDto";
import { DsnNatureDeclaration } from "../../dto/GenApi.iNotPaie.Dto/DsnNatureDeclaration";
import { EffectifDto } from "../../dto/GenApi.iNotPaie.Dto/EffectifDto";
import { ElementVariableAEditerDto } from "../../dto/GenApi.iNotPaie.Dto/ElementVariableAEditerDto";
import { EnregistrementAbsenceDto } from "../../dto/GenApi.iNotPaie.Dto/EnregistrementAbsenceDto";
import { EntiteAttenteTransfertDto } from "../../dto/GenApi.iNotPaie.Dto/EntiteAttenteTransfertDto";
import { EntreeSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/EntreeSalarieDto";
import { EtatSaisie } from "../../dto/GenApi.iNotPaie.Dto/EtatSaisie";
import { ExerciceDto } from "../../dto/GenApi.iNotPaie.Dto/ExerciceDto";
import { ExerciceHistoryDto } from "../../dto/GenApi.iNotPaie.Dto/ExerciceHistoryDto";
import { FeatureFlagDto } from "../../dto/GenApi.iNotPaie.Dto/FeatureFlagDto";
import { FicheSalarieAbsenceDto } from "../../dto/GenApi.iNotPaie.Dto/FicheSalarieAbsenceDto";
import { HeaderDto } from "../../dto/GenApi.iNotPaie.Dto/HeaderDto";
import { HoraireHebdoDto } from "../../dto/GenApi.iNotPaie.Dto/HoraireHebdoDto";
import { ImportDsnAutoDto } from "../../dto/GenApi.iNotPaie.Dto/ImportDsnAutoDto";
import { InfosSalariePourAbsenceDto } from "../../dto/GenApi.iNotPaie.Dto/InfosSalariePourAbsenceDto";
import { JourFerieDto } from "../../dto/GenApi.iNotPaie.Dto/JourFerieDto";
import { LigneDeclarationChargesDto } from "../../dto/GenApi.iNotPaie.Dto/LigneDeclarationChargesDto";
import { LigneJournalDto } from "../../dto/GenApi.iNotPaie.Dto/LigneJournalDto";
import { LigneVariableDto } from "../../dto/GenApi.iNotPaie.Dto/LigneVariableDto";
import { MessageDto } from "../../dto/GenApi.iNotPaie.Dto/MessageDto";
import { ModelRequeteDto } from "../../dto/GenApi.iNotPaie.Dto/ModelRequeteDto";
import { ModificationMdpUrssafDto } from "../../dto/GenApi.iNotPaie.Dto/ModificationMdpUrssafDto";
import { NeoresEffectifDto } from "../../dto/GenApi.iNotPaie.Dto/NeoresEffectifDto";
import { OrganismeDto } from "../../dto/GenApi.iNotPaie.Dto/OrganismeDto";
import { ParametrageCalendrierDto } from "../../dto/GenApi.iNotPaie.Dto/ParametrageCalendrierDto";
import { ParametrageLibellesDto } from "../../dto/GenApi.iNotPaie.Dto/ParametrageLibellesDto";
import { ParametrageModuleEnum } from "../../dto/GenApi.iNotPaie.Dto/ParametrageModuleEnum";
import { ParametrageModuleIdEnum } from "../../dto/GenApi.iNotPaie.Dto/ParametrageModuleIdEnum";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { ParametreModuleDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreModuleDto";
import { PrimoboxExerciceDto } from "../../dto/GenApi.iNotPaie.Dto/PrimoboxExerciceDto";
import { PrimoboxTraitementDetailDto } from "../../dto/GenApi.iNotPaie.Dto/PrimoboxTraitementDetailDto";
import { ProfilUtilisateurDto } from "../../dto/GenApi.iNotPaie.Dto/ProfilUtilisateurDto";
import { PropositionEntreeSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/PropositionEntreeSalarieDto";
import { ReglementTypeDto } from "../../dto/GenApi.iNotPaie.Dto/ReglementTypeDto";
import { RegleSequenceCalculDto } from "../../dto/GenApi.iNotPaie.Dto/RegleSequenceCalculDto";
import { RequeteurDto } from "../../dto/GenApi.iNotPaie.Dto/RequeteurDto";
import { ResponsableHierarchiqueDto } from "../../dto/GenApi.iNotPaie.Dto/ResponsableHierarchiqueDto";
import { RubriqueContratDto } from "../../dto/GenApi.iNotPaie.Dto/RubriqueContratDto";
import { RubriqueDetailDto } from "../../dto/GenApi.iNotPaie.Dto/RubriqueDetailDto";
import { RubriqueDto } from "../../dto/GenApi.iNotPaie.Dto/RubriqueDto";
import { RubriqueGeneraleDto } from "../../dto/GenApi.iNotPaie.Dto/RubriqueGeneraleDto";
import { SalarieAbsenceCollectiveDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieAbsenceCollectiveDto";
import { SalarieAbsencesDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieAbsencesDto";
import { SalarieCommonInfoDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieCommonInfoDto";
import { SalarieCompetenceDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieCompetenceDto";
import { SalarieConnecteDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieConnecteDto";
import { SalarieContratDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieContratDto";
import { SalarieContratHistoriqueDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieContratHistoriqueDto";
import { SalarieContratIdsDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieContratIdsDto";
import { SalarieDeclarationDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieDeclarationDto";
import { SalarieDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieDto";
import { SalarieIdentiteDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieIdentiteDto";
import { SalarieLightDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieLightDto";
import { SalarieNotesDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieNotesDto";
import { SalarieReglementDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieReglementDto";
import { SalarieTopazeDto } from "../../dto/GenApi.iNotPaie.Dto/SalarieTopazeDto";
import { ScenarioDto } from "../../dto/GenApi.iNotPaie.Dto/ScenarioDto";
import { ScenariosDto } from "../../dto/GenApi.iNotPaie.Dto/ScenariosDto";
import { ServiceStatusDto } from "../../dto/GenApi.iNotPaie.Dto/ServiceStatusDto";
import { SocieteAdministratifDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteAdministratifDto";
import { SocieteCreationCommandDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteCreationCommandDto";
import { SocieteDsnDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteDsnDto";
import { SocieteDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteDto";
import { SocieteParametrageDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteParametrageDto";
import { SocieteReglementsDto } from "../../dto/GenApi.iNotPaie.Dto/SocieteReglementsDto";
import { SortieSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/SortieSalarieDto";
import { StatuAbsenceDto } from "../../dto/GenApi.iNotPaie.Dto/StatuAbsenceDto";
import { StatuAbsenceSalarieDto } from "../../dto/GenApi.iNotPaie.Dto/StatuAbsenceSalarieDto";
import { TableauDto } from "../../dto/GenApi.iNotPaie.Dto/TableauDto";
import { UtilisateurExterneDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurExterneDto";
import { UtilisateurLightDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurLightDto";
import { UtilisateurSsoDto } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurSsoDto";
import { UtilisateurSSORolesTalent } from "../../dto/GenApi.iNotPaie.Dto/UtilisateurSSORolesTalent";
import { ValideurCongesDto } from "../../dto/GenApi.iNotPaie.Dto/ValideurCongesDto";
import { VariableHistoryDto } from "../../dto/GenApi.iNotPaie.Dto/VariableHistoryDto";
import { MethodesFetch } from "../../shared/Enums/ServicesFactory/MethodesFetch";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { EventBus } from "./EventBus";
import { ParametresInstance } from "./Parameters";

const window: any = document.defaultView;
// eslint-disable-next-line @typescript-eslint/no-var-requires
window.$ = require("jquery")(window);
window.jQuery = $;
require("ms-signalr-client");

interface ErreurValidationMetier {
    Message: string,
    NomPropriete: string
}

interface ValidationMetier {
    ErreursDeValidation: ErreurValidationMetier[],
    HasErrors: boolean,
    MessageGlobal: string,
    Messages: string[]
}

export class ServiceBase {
    /*
    * methode globales
    */

    protected onError(reason: any, service: string, onrejected?: (reason: any) => void): void {
        if (service != "") {
            console.warn("Service error :  " + service);
        }
        console.warn(reason);
        NotificationServiceInstance.SendFailed(reason);

        if (onrejected) {
            onrejected(reason);
        }
    }

    protected checkAxiosError(error: any, _this: ServiceBase, url: string, onrejected?: (reason: any) => void): void {
        try {
            const axiosError = error as AxiosError;

            if (!axiosError) {
                throw "L'erreur Axios n'a pas pu être récupérée";
            }

            const codeErreur = axiosError.response?.status ? axiosError.response.status.toString() : "Axios";
            const validationMetier: ValidationMetier | undefined = codeErreur === "417" ? axiosError.response?.data : undefined;
            const titre = this.getTitreErreur(codeErreur, validationMetier);
            let detail: string;
            if (validationMetier) {
                detail = this.getDetailErreurMetier(validationMetier);
            } else {
                detail = axiosError?.response?.data ? JSON.stringify(axiosError.response.data) : "Aucun détail";
            }

            throw this.getMessageErreur(titre, detail);
        } catch (e) {
            this.onError(e, url, onrejected);
        }
    }

    protected async checkResponseAsync(response: Response): Promise<Response> {
        if (!response.ok) {
            const messageErreur = await this.getMessageErreurExceptionAsync(response);
            throw messageErreur;
        }

        return response;
    }

    protected async getMessageErreurExceptionAsync(response: Response): Promise<string> {
        const validationMetier = response.status === 417 ? await this.getValidationMetierAsync(response) : undefined;
        const titre = this.getTitreErreur(response.status.toString(), validationMetier);

        let detail: string;
        switch (response.status) {
            case 401:
                detail = "Accès à un service non autorisé";
                break;
            case 417:
                detail = this.getDetailErreurMetier(validationMetier);
                break;
            default:
                detail = await response.text() ?? "Aucun détail";
                break;
        }

        return this.getMessageErreur(titre, detail);
    }

    protected getTitreErreur(libelleCodeErreur: string, validationMetier?: ValidationMetier): string {
        const texteErreur = validationMetier?.MessageGlobal?.length ? validationMetier.MessageGlobal : "La demande a échoué";

        return `Erreur ${libelleCodeErreur} - ${texteErreur}`;
    }

    protected getDetailErreurMetier(validationMetier?: ValidationMetier): string {
        if (!validationMetier?.Messages?.length) {
            return "Aucun détail";
        }

        const lignesDetail: string[] = [];
        lignesDetail.push(validationMetier.Messages.join("<BR>"));

        return lignesDetail.join("");
    }

    protected getMessageErreur(titre: string, detail: string): string {
        return `<strong>${titre} :</strong><BR>${detail}`;
    }

    protected async getValidationMetierAsync(response: Response): Promise<ValidationMetier> {
        let validationMetier;

        try {
            validationMetier = await response.json() as ValidationMetier;
        } catch (error) {
            throw `Erreur lors de la récupération de l'erreur métier : ${error instanceof Error ? error.message : "Erreur inconnue"}`;
        }

        return validationMetier;
    }

    protected async extractDtoFromResponseAsync<T>(response: Response): Promise<T> {
        try {
            const text = await response.text();

            return text ? JSON.parse(text) : undefined;
        } catch (error) {
            throw `Erreur lors de l'extraction JSON de la réponse' : ${error instanceof Error ? error.message : "Erreur inconnue"}`;
        }
    }

    protected async extractBlobFromResponseAsync(response: Response): Promise<Blob> {
        try {
            return await response.blob();
        } catch (error) {
            throw `Erreur lors de l'extraction Blob de la réponse' : ${error instanceof Error ? error.message : "Erreur inconnue"}`;
        }
    }

    /**
     * permet de construire les entête des requètes
     */
    protected getUploadFilesRequestInfo(): any {
        return {
            headers:
            {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${ServicesFactoryInstance.TokenAuthentication.token}`
            }
        };
    }

    protected getRequestHeader(methode: MethodesFetch, data?: any): any {
        const headers = data
            ? { "content-type": "application/json", Authorization: "Bearer " + ServicesFactoryInstance.TokenAuthentication.token }
            : { Authorization: "Bearer " + ServicesFactoryInstance.TokenAuthentication.token };

        return {
            body: (data ? JSON.stringify(data) : undefined),
            method: methode,
            headers: headers
        };
    }

    protected getCodeSociete(onrejected?: any): string {
        if (ParametresInstance.societeCourante == undefined || ParametresInstance.societeCourante.Code == undefined) {
            if (onrejected != undefined) {
                onrejected(null);
            }

            return "";
        }

        return ParametresInstance.societeCourante.Code;
    }

    protected getIdSociete(onrejected?: any): number {
        if (ParametresInstance.societeCourante == undefined) {
            if (onrejected != undefined) {
                onrejected(null);
            }

            return 0;
        }

        return ParametresInstance.societeCourante.Id;
    }

    /**
     * Méthodes d'interrogation du serveur
     */

    /**
     * Envoie une requête au backend et en récupère une réponse, dont le status est en premier lieu vérifié.
     * La réponse contient un objet qui est alors sérialisé, avant de passer par une vérification d'une erreur métier.
     *
     * @param {string} url
     * @param {MethodesFetch} method
     * @param onfulfilled
     * @param onrejected
     * @param {any} sentObject
     * @template T
     */
    protected fetchApi<T>(url: string, method: MethodesFetch, onfulfilled?: (result: T) => void, onrejected?: (error: any) => void, sentObject?: any): Promise<void> {
        return fetch(url, this.getRequestHeader(method, sentObject))
            .then(r => this.checkResponseAsync(r))
            .then(r => this.extractDtoFromResponseAsync<T>(r))
            .then(result => {
                if (onfulfilled) {
                    onfulfilled(result);
                }
            })
            .catch(error => {
                this.onError(error, url, onrejected);
            });
    }

    protected async fetchApiData<T>(url: string, method: MethodesFetch, sentObject?: any): Promise<T> {
        return fetch(url, this.getRequestHeader(method, sentObject))
            .then((response) => this.checkResponseAsync(response))
            .then((checked) => this.extractDtoFromResponseAsync<T>(checked))
            .catch(error => {
                this.onError(error, url);
                throw error;
            });
    }

    /**
     * Envoie une requête pour un traitement long qui ne sera pas bloquant pour l'utilisateur.
     * @param {string} url
     * @param {MethodesFetch} method
     * @param {any} sentObject
     * @returns
     */
    protected fetchApiBackgroundTask<T>(url: string, method: MethodesFetch, sentObject?: any): Promise<void | Response> {
        return fetch(url, this.getRequestHeader(method, sentObject)).catch(error => {
            console.warn(error);
        });
    }

    /**
     * Envoie une requête au backend et en récupère une réponse, dont le status et en premier lieu vérifié.
     * La réponse contient un objet qui est alors transformé en blob en cas de succès, en JSON dans le cas contraire.
     *
     * @param {string} url
     * @param {MethodesFetch} method
     * @param onfulfilled
     * @param onrejected
     * @param {any} sentObject
     */
    protected fetchApiBlob(url: string, method: MethodesFetch, onfulfilled?: (blob: Blob) => void, onrejected?: (error: any) => void, sentObject?: any): Promise<void> {
        return fetch(url, this.getRequestHeader(method, sentObject))
            .then(r => this.checkResponseAsync(r))
            .then(r => this.extractBlobFromResponseAsync(r))
            .then(blob => {
                if (onfulfilled) {
                    onfulfilled(blob);
                }
            })
            .catch(error => {
                this.onError(error, url, onrejected);
            });
    }
}

/** **************************Services**********************************/
export class AuthenticationService extends ServiceBase {
    public register(userName: string, password: string): void {
        fetch(ServicesFactoryInstance.urlBase + "/api/account/register", {
            body: JSON.stringify({
                UserName: userName,
                ProfilName: userName,
                Password: password,
                ConfirmPassword: password
            }),
            method: "POST",
            headers:
            {
                "content-type": "application/json"
            }
        }).then(response => {
            if (!response.ok) {
                throw response.statusText;
            }
        }).catch((e) => this.onError(e, ServicesFactoryInstance.urlBase + "/api/account/register"));
    }

    public login(user: string, password: string, onfulfilled?: (value: any) => void, onrejected?: (reason: any) => void): void {
        fetch("/token", {
            body: "grant_type=password&username=" + user + "&password=" + password,
            method: "POST",
            headers:
            {
                "content-type": "application/x-www-form-urlencoded"
            }
        }).then(response => {
            if (!response.ok) {
                throw "Echec de la connection !";
            }

            return response;
        }).then(response => response.json())
            .then(onfulfilled)
            .catch((e) => this.onError(e, "token", onrejected));
    }

    public setToken(token: any): void {
        console.warn("==> ServiceFactory.ts : call of setToken : " + token);
        ServicesFactoryInstance.TokenAuthentication.token = token.access_token as string;
        ServicesFactoryInstance.TokenAuthentication.userName = token.userName as string;
        LocalStorageService.set(iNotPaieStorageKeys.TOKEN, ServicesFactoryInstance.TokenAuthentication.token);
    }

    public removeToken(): void {
        console.warn("==> ServiceFactory.ts : call of removeToken");
        ServicesFactoryInstance.TokenAuthentication.token = "";
        ServicesFactoryInstance.TokenAuthentication.userName = "";
        LocalStorageService.remove(iNotPaieStorageKeys.TOKEN);
    }

    public redirectToSSO(returnUrl: string, icare: string | undefined = undefined): void {
        const state = Math.random().toString(36).substring(7);
        LocalStorageService.set(iNotPaieStorageKeys.OAUTH_STATE, state);
        let url = ServicesFactoryInstance.urlBase + "/api/Account/ExternalLogin?provider=SSO&response_type=token";

        if (icare != undefined) {
            url = url + "&icare=" + icare;
        }

        url = url + "&client_id=self&state=" + state + "&redirect_uri=" + encodeURIComponent(returnUrl);

        console.warn("==> ServiceFactory.ts : call of redirectToSSO with url = " + url);
        console.warn("==> ServiceFactory.ts : call of redirectToSSO with return url = " + returnUrl);
        window.location.href = url;
    }

    public logout(): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Account/logout?returnUrl=" + encodeURIComponent(window.location.origin);
        fetch(url, {
            method: "POST",
            headers: { Authorization: "Bearer " + ServicesFactoryInstance.TokenAuthentication.token }
        }).then((response) => {
            response.text().then(function (text) {
                ServicesFactoryInstance.AuthenticationService.removeToken();
                window.location.href = text.replace("\"", "").replace("\"", "");
            });
        })
            .catch((e) => {
                console.warn("Erreur de déconnection");
                console.warn(e);
            });
        console.warn("==> ServiceFactory.ts : call of logout");
        // this.removeToken();
    }

    public Connect(onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        fetch(ServicesFactoryInstance.urlBase + "/api/connect", {
            method: "POST",
            headers: { Authorization: "Bearer " + ServicesFactoryInstance.TokenAuthentication.token }
        }).then(response => {
            if (!response.ok) {
                throw response.statusText;
            }
        }).then(onfulfilled)
            .catch((e) => {
                this.onError(e, ServicesFactoryInstance.urlBase + "/api/connect", onrejected);
                ServicesFactoryInstance.AuthenticationService.logout();
            });
    }
}

export class GedService extends ServiceBase {
    public getDocument(codeDocument: string, onfulfilled?: (value: Blob) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/document/${codeDocument}`;
        this.fetchApiBlob(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getArchive(documents: DocumentInfoDto[], onfulfilled?: (value: DocumentsArchiveDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/documents/archive`;
        this.fetchApi<DocumentsArchiveDto>(url, MethodesFetch.POST, onfulfilled, onrejected, documents);
    }

    public getArchiveDossiers(elementsATelecharger: CommandeTelechargementArchive, onfulfilled?: (value: DocumentsArchiveDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/archiveTypeMultiple`;
        this.fetchApi<DocumentsArchiveDto>(url, MethodesFetch.POST, onfulfilled, onrejected, elementsATelecharger);
    }

    public getDossierRacine(onfulfilled?: (value: DossierGedDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/dossier?path=${codeSociete}`;
        this.fetchApi<DossierGedDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

	public getDocumentsFromPath(path: string,onfulfilled?: (value: DossierGedDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/dossier?path=${encodeURIComponent(path)}`;

		this.fetchApi<DossierGedDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
	}

	public ajoutDossier(dossier: DossierDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
		const url = `${ServicesFactoryInstance.urlBase}/api/dossier`;
		this.fetchApi<DossierDto>(url, MethodesFetch.POST, onfulfilled, onrejected, dossier);
	}

    public ajoutDocument(document: DocumentGedDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/document`;
        this.fetchApi<DocumentGedDto>(url, MethodesFetch.POST, onfulfilled, onrejected, document);
    }

    public deleteDossier(dossier: DossierGedDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/dossier`;
        this.fetchApi<DossierGedDto>(url, MethodesFetch.DELETE, onfulfilled, onrejected, dossier);
    }

	public deleteDossiers(commande: CommandeActionDossiersGedDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): Promise<void> {
		const url = `${ServicesFactoryInstance.urlBase}/api/dossiers`;
		return this.fetchApi<CommandeActionDossiersGedDto>(url, MethodesFetch.DELETE, onfulfilled, onrejected, commande);
	}

    public deleteDocument(document: DocumentGedDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/document`;
        this.fetchApi<DocumentGedDto>(url, MethodesFetch.DELETE, onfulfilled, onrejected, document);
    }

	public deleteDocuments(commande: CommandeActionDocumentsGedDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): Promise<void> {
		const url = `${ServicesFactoryInstance.urlBase}/api/documents`;
		return this.fetchApi<CommandeActionDocumentsGedDto>(url, MethodesFetch.DELETE, onfulfilled, onrejected, commande);
	}
}

export class SalarieService extends ServiceBase {
    public getSalarieContratHistorique(id: number, onfulfilled?: (value: SalarieContratHistoriqueDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieContratHistorique/" + id + "/" + codeSociete;
        this.fetchApi<SalarieContratHistoriqueDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalarieQualification(id: number, onfulfilled?: (value: SalarieContratDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieQualifications/" + id + "/" + codeSociete;
        this.fetchApi<SalarieContratDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalarieQualificationForContrat(id: number, idContrat: number, onfulfilled?: (value: SalarieContratDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieQualifications/" + id + "/" + codeSociete + "/" + idContrat;
        this.fetchApi<SalarieContratDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalarieDeclaration(id: number, onfulfilled?: (value: SalarieDeclarationDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieDeclaration/" + id + "/" + codeSociete;
        this.fetchApi<SalarieDeclarationDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalarieDeclarationForContrat(id: number, idContrat: number, onfulfilled?: (value: SalarieDeclarationDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieDeclaration/" + id + "/" + codeSociete + "/" + idContrat;
        this.fetchApi<SalarieDeclarationDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalarieCompetences(id: number, onfulfilled?: (value: SalarieCompetenceDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/SalarieCompetence/" + id;
        this.fetchApi<SalarieCompetenceDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalarieReglements(id: number, onfulfilled?: (value: SalarieReglementDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieReglement/" + codeSociete + "/" + id;
        this.fetchApi<SalarieReglementDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalarieDocuments(id: number, path: string, onfulfilled?: (value: DossierGedDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieDocuments/" + id + "/" + codeSociete + "?cheminLogique=" + path;
        this.fetchApi<DossierGedDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public delete(id: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/SalarieIdentite/" + id;
        this.fetchApi<number>(url, MethodesFetch.DELETE, onfulfilled, onrejected, id);
    }

    public getSalarieIdentite(id: number, onfulfilled?: (value: SalarieIdentiteDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieIdentite/" + id + "/" + codeSociete;
        this.fetchApi<SalarieIdentiteDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalarieIdentiteForContrat(id: number, idContrat: number, onfulfilled?: (value: SalarieIdentiteDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieIdentite/" + id + "/" + codeSociete + "/" + idContrat;
        this.fetchApi<SalarieIdentiteDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalarieLight(id: number, onfulfilled?: (value: SalarieLightDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieLight/" + id + "/" + codeSociete;
        this.fetchApi<SalarieLightDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalarieAbsences(id: number, onfulfilled?: (value: SalarieAbsencesDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieAbsences/" + id;
        this.fetchApi<SalarieAbsencesDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateSalarieAbsences(salarie: SalarieAbsencesDto, onfulfilled?: (salarie: SalarieAbsencesDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieAbsences";
        this.fetchApi<SalarieAbsencesDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, salarie);
    }

    public getSalarieCommonInfo(id: number, onfulfilled?: (value: SalarieCommonInfoDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieCommonInfo/" + id + "/" + codeSociete;
        this.fetchApi<SalarieCommonInfoDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalarieCommonInfoFoContrat(id: number, idContrat: number, onfulfilled?: (value: SalarieCommonInfoDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieCommonInfo/" + id + "/" + codeSociete + "/" + idContrat;
        this.fetchApi<SalarieCommonInfoDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalaries(onfulfilled?: (value: SalarieDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/Salaries/" + codeSociete;
        this.fetchApi<SalarieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalariesActifs(onfulfilled?: (value: SalarieDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/Salaries/" + codeSociete + "/Actifs";
        this.fetchApi<SalarieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalariesPourAbsenceCollective(dateDebutPeriode: Date, estDebutPeriodeApresMidi: boolean, dateFinPeriode: Date, estFinPeriodeMatin: boolean, onfulfilled?: (value: SalarieAbsenceCollectiveDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const commande: CommandeGetAbsenceCollectiveDto = {
            CodeSociete: codeSociete,
            DateDebutPeriode: dateDebutPeriode,
            EstDebutPeriodeApresMidi: estDebutPeriodeApresMidi,
            DateFinPeriode: dateFinPeriode,
            EstFinPeriodeMatin: estFinPeriodeMatin
        };

        const url = `${ServicesFactoryInstance.urlBase}/api/SalariesPourAbsenceCollective`;
        this.fetchApi<SalarieAbsenceCollectiveDto[]>(url, MethodesFetch.POST, onfulfilled, onrejected, commande);
    }

    public updateSalarieIdentite(salarie: SalarieIdentiteDto, onfulfilled?: (salarie: SalarieIdentiteDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        salarie.CodeSociete = codeSociete;

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieIdentite";
        this.fetchApi<SalarieIdentiteDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, salarie);
    }

    public updateSalarieLight(salarie: SalarieLightDto, onfulfilled?: (salarie: SalarieLightDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        salarie.CodeSociete = codeSociete;
        const url = ServicesFactoryInstance.urlBase + "/api/SalarieLight";
        this.fetchApi<SalarieLightDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, salarie);
    }

    public updateSalarieQualifications(contrat: SalarieContratDto, onfulfilled?: (salarie: SalarieContratDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }
        contrat.CodeSociete = codeSociete;

        const url = `${ServicesFactoryInstance.urlBase}/api/SalarieQualifications`;
        this.fetchApi<SalarieContratDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, contrat);
    }

    public updateSalarieContrat(contrat: SalarieContratDto, onfulfilled?: (salarie: SalarieContratDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }
        contrat.CodeSociete = codeSociete;

        const url = `${ServicesFactoryInstance.urlBase}/api/SalarieContrat`;
        this.fetchApi<SalarieContratDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, contrat);
    }

    public deleteContrat(idContrat: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/DeleteContrat/" + idContrat;
        this.fetchApi<number>(url, MethodesFetch.DELETE, onfulfilled, onrejected, idContrat);
    }

    public CreateContrat(idContrat: number, onfulfilled?: (salarie: SalarieContratDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/CreateContrat/" + idContrat + "/" + codeSociete;
        this.fetchApi<SalarieContratDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalariesEnCours(onfulfilled?: (value: SalarieDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);

        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/Salaries/" + codeSociete + "/EnCours";
        this.fetchApi<SalarieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public FaireSortie(idContrat: number, onfulfilled?: (salarie: SalarieContratDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/FaireSortie/" + idContrat;
        this.fetchApi<SalarieContratDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateSalarieDeclaration(salarie: SalarieDeclarationDto, onfulfilled?: (salarie: SalarieDeclarationDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        salarie.CodeSociete = codeSociete;

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieDeclaration";
        this.fetchApi<SalarieDeclarationDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, salarie);
    }

    public updateSalarieCompetence(salarie: SalarieCompetenceDto, onfulfilled?: (salarie: SalarieCompetenceDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/SalarieCompetence";
        this.fetchApi<SalarieCompetenceDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, salarie);
    }

    public updateSalarieReglement(salarie: SalarieReglementDto, onfulfilled?: (salarie: SalarieReglementDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        salarie.CodeSociete = codeSociete;

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieReglement";
        this.fetchApi<SalarieReglementDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, salarie);
    }

    public createSalarieIdentite(salarie: SalarieIdentiteDto, onfulfilled?: (salarie: SalarieIdentiteDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        salarie.CodeSociete = codeSociete;

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieIdentite";
        this.fetchApi<SalarieIdentiteDto>(url, MethodesFetch.POST, onfulfilled, onrejected, salarie);
    }

    public getNotes(id: number, onfulfilled?: (value: SalarieNotesDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Notes/" + id;
        this.fetchApi<SalarieNotesDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateNotes(salarie: SalarieNotesDto, onfulfilled?: (id: number) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Notes";
        this.fetchApi<number>(url, MethodesFetch.PUT, onfulfilled, onrejected, salarie);
    }

    public getSalarieContratType(onfulfilled?: (value: SalarieContratDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/ContratType/" + codeSociete;
        this.fetchApi<SalarieContratDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateUpdateContratType(contrat: SalarieContratDto, onfulfilled?: (contratUploaded: SalarieContratDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        contrat.CodeSociete = codeSociete;

        const url = ServicesFactoryInstance.urlBase + "/api/ContratType";
        this.fetchApi<SalarieContratDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, contrat);
    }

    public getSalariesByAbsenceImposee(idAbsenceImposee: number, onfulfilled?: (value: InfosSalariePourAbsenceDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalariesByAbsenceImposee/" + idAbsenceImposee + "/" + codeSociete;
        this.fetchApi<InfosSalariePourAbsenceDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSalariesAbsenceImposeeCalcule(idAbsenceImposee: number, onfulfilled?: (value: InfosSalariePourAbsenceDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/GetSalariesAbsenceImposeeCalcule/" + idAbsenceImposee + "/" + codeSociete;
        this.fetchApi<InfosSalariePourAbsenceDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public exportListSalariesExcel(commande: CommandeEditionListeSalariesDto, onfulfilled?: (value: Blob) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalariesExcel";
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, commande);
    }

    public getListeResponsablesHierarchiques(onfulfilled?: (value: ResponsableHierarchiqueDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/ListeResponsablesHierarchiques/${codeSociete}`;
        this.fetchApi<ResponsableHierarchiqueDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getMostRecentContratTermine(idSalarie: number, onfulfilled?: (value: SalarieContratDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/GetMostRecentContratTermine/${idSalarie}/${codeSociete}`;
        this.fetchApi<SalarieContratDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetLastContrat(idSalarie: number, onfulfilled?: (value: SalarieContratDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/GetLastContrat/${idSalarie}/${codeSociete}`;
        this.fetchApi<SalarieContratDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetContratsActifs(onfulfilled?: (value: ContratSalarieNameDto[]) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + `/api/GetContratsActifs/${idSociete}`;
        this.fetchApi<ContratSalarieNameDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class OrganismeService extends ServiceBase {
    public updateOrganisme(organisme: OrganismeDto, onfulfilled?: (value: OrganismeDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        organisme.CodeSociete = codeSociete;

        const url = ServicesFactoryInstance.urlBase + "/api/Organisme";
        this.fetchApi<OrganismeDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, organisme);
    }
}

export class ParametreService extends ServiceBase {
    public addParametre(parametre: ParametreDto, onfulfilled?: (value: ParametreDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Parametre";
        this.fetchApi<ParametreDto>(url, MethodesFetch.POST, onfulfilled, onrejected, parametre);
    }

    public updateParametre(parametre: ParametreDto, onfulfilled?: (value: ParametreDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Parametre";
        this.fetchApi<ParametreDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, parametre);
    }

    public updateParametreRubContrat(parametre: ParametreDto[], onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ParametreRubContrat";
        this.fetchApi<ParametreDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, parametre);
    }

    public getParametre(id: string, onfulfilled?: (value: ParametreDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Parametre/" + id;
        this.fetchApi<ParametreDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public archiverParametre(id: number, onfulfilled?: (value: number) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Parametre/" + id;
        this.fetchApi<number>(url, MethodesFetch.DELETE, onfulfilled, onrejected, id);
    }
}

export class AideEnLigneService extends ServiceBase {
    public getAideEnLigne(onfulfilled?: (value: AideEnLigneDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/AideEnLigne";
        this.fetchApi<AideEnLigneDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getAideEnLigneUrl(onfulfilled?: (value: string) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/AideEnLigneUrl";
        this.fetchApi<string>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class UtilisateurExterneService extends ServiceBase {
    public getListe(onfulfilled?: (value: UtilisateurExterneDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/utilisateursExternes`;
        this.fetchApi<UtilisateurExterneDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public save(notaire: UtilisateurExterneDto, onfulfilled?: (value: UtilisateurExterneDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/utilisateurExterne`;
        this.fetchApi<UtilisateurExterneDto>(url, MethodesFetch.POST, onfulfilled, onrejected, notaire);
    }

    public get(id: number, onfulfilled?: (value: UtilisateurExterneDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/utilisateurExterne/${id}`;
        this.fetchApi<UtilisateurExterneDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public delete(id: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/utilisateurExterne/${id}`;
        this.fetchApi<number>(url, MethodesFetch.DELETE, onfulfilled, onrejected, id);
    }
}

export class ParametreSpecifiqueService extends ServiceBase {
    public create(parametre: RubriqueContratDto, onfulfilled?: (value: RubriqueContratDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        parametre.CodeSociete = codeSociete;

        const url = ServicesFactoryInstance.urlBase + "/api/ParametreSpecifique";
        this.fetchApi<RubriqueContratDto>(url, MethodesFetch.POST, onfulfilled, onrejected, parametre);
    }

    public update(parametre: RubriqueContratDto, onfulfilled?: (value: RubriqueContratDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        parametre.CodeSociete = codeSociete;

        const url = ServicesFactoryInstance.urlBase + "/api/ParametreSpecifique";
        this.fetchApi<RubriqueContratDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, parametre);
    }

    public delete(id: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ParametreSpecifique/" + id;
        this.fetchApi<number>(url, MethodesFetch.DELETE, onfulfilled, onrejected, id);
    }

    public getListe(onfulfilled?: (value: RubriqueDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/ParametresSpecifiques/" + codeSociete;
        this.fetchApi<RubriqueDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class ParametresService extends ServiceBase {
    public getParametresGenerauxAssocies(idRubrique: number, onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/parametresGenerauxassocies/${idRubrique}`;
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getTypesPreavis(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/TypePreavis";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getRegimes(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Regimes";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getParametres(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Parametres";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getParametrageLibelles(onfulfilled?: (value: ParametrageLibellesDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/ParametrageLibelles`;
        this.fetchApi<ParametrageLibellesDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getTypeConges(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/TypeConges";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public async getFonctions(): Promise<ParametreDto[]> {
        const url = ServicesFactoryInstance.urlBase + "/api/Fonctions";

        return await this.fetchApiData(url, MethodesFetch.GET);
    }

    public getArrondis(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Arrondis";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getOperateurs(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Operateurs";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getMotifReprises(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/MotifReprises";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getMotifRuptures(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/MotifRuptures";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getMutuelles(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Mutuelles";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getPrevoyances(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Prevoyances";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getTransports(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Transports";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getGestionConges(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/GestionConges";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getCaisseComplementaires(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/CaisseComplementaires";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getRemunerations(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Remunerations";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getMaladieRetraites(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/MaladieRetraites";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getTypeContrats(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/TypeContrats";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getDureeContrats(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/DureeContrats";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getNatureContrats(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/NatureContrats";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getMotifDeparts(inclusMotifsArchives?: boolean, onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        let url = `${ServicesFactoryInstance.urlBase}/api/MotifDeparts`;
        if (inclusMotifsArchives != undefined) {
            url = `${url}?inclureMotifsArchives=${inclusMotifsArchives}`;
        }

        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getMotifDebuts(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/MotifDebuts";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getClassifications(inclureElementsArchives: boolean, onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/Classifications/${inclureElementsArchives}`;
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getConventionsCollectives(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ConventionsCollectives";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getCodeInsees(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/CodeInsees";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getQualifications(inclureElementsArchives: boolean, onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/Qualifications/${inclureElementsArchives}`;
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getQualificationsSalarie(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/QualificationsSalarie";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getPays(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Pays";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getCivilites(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Civilites";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSections(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Sections";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getTempsPartielCotisantTempsPleins(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/TempsPartielCotisantTempsPleins";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getLieuVotes(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/LieuVotes";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getColleges(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Colleges";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSituationMaritale(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/SituationMaritale";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getTypeVariable(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/TypeVariable";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getMotifRecours(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/MotifRecours";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getServices(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Services";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getHandicapes(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/handicapes";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getDiplomesPrepares(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/DiplomesPrepares";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getListeModesPaiementOrganismes(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ListeModesPaiementOrganismes";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getListePoints(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ListePoints";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getParametrageCalendrier(onfulfilled?: (value: ParametrageCalendrierDto) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/ParametrageCalendrier/${idSociete}`;
        this.fetchApi<ParametrageCalendrierDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getListeTypesMajoration(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/ListeTypesMajoration`;
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getListeVariablesCsv(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/listevariablescsv`;
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getListeCodesUrssaf(onfulfilled?: (value: CodeUrssafDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/CodesUrssaf`;
        this.fetchApi<CodeUrssafDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getListeCodesSst(codeUrssaf: string, onfulfilled?: (value: CodeSstDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/CodesSst/${codeUrssaf}`;
        this.fetchApi<CodeSstDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getListeFeatureFlag(onfulfilled?: (value: FeatureFlagDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/featureFlag`;
        this.fetchApi<FeatureFlagDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class ConfigurationEtudeService extends ServiceBase {
    public get(onfulfilled?: (value: ConfigurationEtudeDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ConfigurationEtude";
        this.fetchApi<ConfigurationEtudeDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class RubriquesService extends ServiceBase {
    public getRubriques(onfulfilled?: (value: RubriqueDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Rubriques";
        this.fetchApi<RubriqueDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getRubriquesCodeNat(codeNature: string, onfulfilled?: (value: RubriqueDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Rubriques/" + codeNature;
        this.fetchApi<RubriqueDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getRubriquesNonArchivee(codeNature: string, onfulfilled?: (value: RubriqueDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Rubriques/NonArchivee/" + codeNature;
        this.fetchApi<RubriqueDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
    public getListeRubriquesGenerales(onfulfilled?: (value: RubriqueGeneraleDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/rubriquesgenerales/";
        this.fetchApi<RubriqueGeneraleDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class RubriqueService extends ServiceBase {
    public getRubrique(id: string, onfulfilled?: (value: RubriqueDetailDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Rubrique/" + id;
        this.fetchApi<RubriqueDetailDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public addRubrique(rubrique: RubriqueDetailDto, onfulfilled?: (value: RubriqueDetailDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Rubrique";
        this.fetchApi<RubriqueDetailDto[]>(url, MethodesFetch.POST, onfulfilled, onrejected, rubrique);
    }

    public updateRubrique(rubrique: RubriqueDetailDto, onfulfilled?: (value: RubriqueDetailDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Rubrique";
        this.fetchApi<RubriqueDetailDto[]>(url, MethodesFetch.PUT, onfulfilled, onrejected, rubrique);
    }

    public updateRubriqueValeur(rubrique: RubriqueGeneraleDto, onfulfilled?: (value: RubriqueDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Rubrique/Valeur";
        this.fetchApi(url, MethodesFetch.PUT, onfulfilled, onrejected, rubrique);
    }

    public archiverRubrique(id: number, onfulfilled?: (value: number) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Rubrique/" + id;
        this.fetchApi<number>(url, MethodesFetch.DELETE, onfulfilled, onrejected, id);
    }
}

export class EditionsService extends ServiceBase {
    public archiverTableau(id: number, onfulfilled?: (value: number) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Tableau/" + id;
        this.fetchApi<number>(url, MethodesFetch.DELETE, onfulfilled, onrejected, id);
    }

    public getEditionTableau(demande: DemandeEditionTableauDto, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/EditerTableau`;
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, demande);
    }

    public getEditionVariablesPdf(elementVariableAEditer: ElementVariableAEditerDto, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/EditionVariables/pdf`;
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, elementVariableAEditer);
    }

    public getEditionVariables(exercice: ExerciceDto, onfulfilled?: (r: LigneVariableDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/EditionVariables";
        this.fetchApi<LigneVariableDto[]>(url, MethodesFetch.POST, onfulfilled, onrejected, exercice);
    }

    public getJournal(demande: DemandeEditionTableauDto, onfulfilled?: (r: LigneJournalDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/journal";
        this.fetchApi<LigneJournalDto[]>(url, MethodesFetch.POST, onfulfilled, onrejected, demande);
    }

    public getDeclarationCharges(demande: DemandeEditionTableauDto, onfulfilled?: (r: LigneDeclarationChargesDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/declarationCharges";
        this.fetchApi<LigneDeclarationChargesDto[]>(url, MethodesFetch.POST, onfulfilled, onrejected, demande);
    }

    public getUrlOdPaie(demande: DemandeEditionTableauDto, onfulfilled?: (r: Blob) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/getUrlOdPaie";
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, demande);
    }

    public getTableaux(onfulfilled?: (value: TableauDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/tableaux";
        this.fetchApi<TableauDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getTableau(id: number, onfulfilled?: (value: TableauDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/tableau/" + id;
        this.fetchApi<TableauDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateTableau(tableau: TableauDto, onfulfilled?: (value: TableauDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/tableau";
        this.fetchApi<TableauDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, tableau);
    }

    public creerTableau(tableau: TableauDto, onfulfilled?: (value: TableauDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/tableau";
        this.fetchApi<TableauDto>(url, MethodesFetch.POST, onfulfilled, onrejected, tableau);
    }

    public editionFinDeMoisByAnneeEtMoisExercice(anneeExercice: number, moisExercice: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/editionsDeFinDeMois/${idSociete}/${anneeExercice}/${moisExercice}`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public editionFinDeMoisCumuleesByAnneeEtMoisExercices(anneeDebut: number, moisDebut: number, anneeFin: number, moisFin: number): void {
        const idSociete = this.getIdSociete();
        if (idSociete == 0) {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/editionFinDeMoisCumuleesByAnneeEtMoisExercice/${idSociete}/${anneeDebut}/${moisDebut}/${anneeFin}/${moisFin}`;
        this.fetchApiBackgroundTask(url, MethodesFetch.GET);
    }

    public getEditionListeSalaries(commande: CommandeEditionListeSalariesDto, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/geteditionlistesalaries`;
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, commande);
    }

    public getEditionListeDSN(commande: DsnDeclarationDetailleeDto, isExcel: boolean, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/getEditionListeDSN/${isExcel}`;
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, commande);
    }

    public GetModeleAvecVariablesByCodeTableau(codeTableau: string, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/tableau/getmodeleavecvariablesbycodetableau?codeTableau=${codeTableau}`;
        this.fetchApiBlob(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public UploadModele(formData: FormData, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/tableau/uploadmodele`;

        axios.post(url, formData, this.getUploadFilesRequestInfo())
            .then(onfulfilled)
            .catch(e => {
                this.checkAxiosError(e, this, url, onrejected);
            });
    }
}

export class ScenariosService extends ServiceBase {
    public getScenariosByNat(codeNature: string, onfulfilled?: (value: ScenariosDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Scenarios/" + codeNature;
        this.fetchApi<ScenariosDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getScenarios(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Scenarios/";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getTypesScenarios(onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/TypesScenarios/";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getScenario(id: string, onfulfilled?: (value: ScenarioDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Scenario/" + id;
        this.fetchApi<ScenarioDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateScenario(scenario: ScenarioDto, onfulfilled?: (value: ScenarioDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Scenario";
        this.fetchApi<ScenarioDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, scenario);
    }

    public addScenario(scenario: ScenarioDto, onfulfilled?: (value: ScenarioDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Scenario";
        this.fetchApi<ScenarioDto>(url, MethodesFetch.POST, onfulfilled, onrejected, scenario);
    }

    public archiverScenario(id: number, onfulfilled?: (value: number) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Scenario/" + id;
        this.fetchApi<number>(url, MethodesFetch.DELETE, onfulfilled, onrejected, id);
    }
}

export class VariablesService extends ServiceBase {
    public getVariables(code?: string, onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Variables?typeScenario=VARIA&sousTypeScenario=" + code;
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateVariables(variables: ParametreDto[], onfulfilled?: (value: ParametreDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Variables";
        this.fetchApi<ParametreDto[]>(url, MethodesFetch.POST, onfulfilled, onrejected, variables);
    }

    public getContratVariables(onfulfilled?: (value: ContratElementVariableDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/ContratVariables?codeSociete=" + codeSociete;
        this.fetchApi<ContratElementVariableDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateContratVariables(contrats: ContratElementVariableDto[], onfulfilled?: (id: number) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/ContratVariables?codeSociete=" + codeSociete;
        this.fetchApi<number>(url, MethodesFetch.POST, onfulfilled, onrejected, contrats);
    }

    public generatePDF(contrats: ContratElementVariableDto[], onfulfilled?: (value: Blob) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/VariablesPdf";
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, contrats);
    }
}

export class VariableCsvService extends ServiceBase {
    public getModeleCsv(inclureContratsActifs: boolean, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/variables/modelecsv?codesociete=${codeSociete}&inclurecontratsactifs=${inclureContratsActifs}`;
        this.fetchApiBlob(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public uploadFichierCsv(idVariableCsv: number, formData: FormData, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/variables/uploadfichiercsv?codesociete=${codeSociete}&idvariablecsv=${idVariableCsv}`;
        axios.post<FormData, AxiosResponse>(url, formData, this.getUploadFilesRequestInfo())
            .then(onfulfilled)
            .catch(e => {
                this.checkAxiosError(e, this, url, onrejected);
            });
    }

    public controleFichierCsv(idVariableCsv: number, formData: FormData, onfulfilled?: (value: ControleFichierCsvDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/variables/controlefichiercsv?codesociete=${codeSociete}&idvariablecsv=${idVariableCsv}`;

        axios.post<FormData, AxiosResponse<ControleFichierCsvDto>>(url, formData, this.getUploadFilesRequestInfo())
            .then((response: AxiosResponse<ControleFichierCsvDto>) => {
                if (onfulfilled) {
                    onfulfilled(response.data);
                }
            })
            .catch(e => {
                this.checkAxiosError(e, this, url, onrejected);
            });
    }
}

export class CommunesService extends ServiceBase {
    public getCommunes(filter: string, onfulfilled?: (value: CommuneDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Communes?filter=" + filter;
        this.fetchApi<CommuneDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class AccueilService extends ServiceBase {
    public getEffectifs(onfulfilled?: (value: EffectifDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/Effectifs/" + codeSociete;
        this.fetchApi<EffectifDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getActualites(onfulfilled?: (value: ActualiteDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Actualites";
        this.fetchApi<ActualiteDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getActivites(showAll: boolean, onfulfilled?: (value: ActiviteDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Activites?showAll=" + showAll;
        this.fetchApi<ActiviteDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getAlertes(onfulfilled?: (value: AlerteDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/Alertes/" + codeSociete;
        this.fetchApi<AlerteDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateActivite(activite: ActiviteDto, onfulfilled?: (activite: ActiviteDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Activite";
        this.fetchApi<ActiviteDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, activite);
    }

    public createActivite(activite: ActiviteDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/Activite`;
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected, activite);
    }

    public deleteActivite(activite: ActiviteDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/Activite`;
        this.fetchApi(url, MethodesFetch.DELETE, onfulfilled, onrejected, activite);
    }
}

export class HeaderService extends ServiceBase {
    public getHeaderInfos(onfulfilled?: (value: HeaderDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Header";
        this.fetchApi<HeaderDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class ExercicesService extends ServiceBase {
    public getExercices(onfulfilled?: (value: ExerciceDto[]) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/Exercices/" + idSociete;
        this.fetchApi<ExerciceDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public creerExercice(onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/Exercice/Creer/${idSociete}`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public creerExerciceInitial(anneeExercice: number, moisExercice: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/Exercice/CreerExerciceInitial/${idSociete}/${anneeExercice}/${moisExercice}`;
        this.fetchApi<ExerciceDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public supprimerExercice(idExercice: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/Exercice/SupprimerExercice/${idExercice}`;
        this.fetchApi<boolean>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public ajoutMessage(message: MessageDto, onfulfilled?: (value: MessageDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Message/";
        this.fetchApi<MessageDto>(url, MethodesFetch.POST, onfulfilled, onrejected, message);
    }

    public updateMessage(message: MessageDto, onfulfilled?: (value: MessageDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Message/";
        this.fetchApi<MessageDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, message);
    }

    public updateSatisfaction(exercice: ExerciceDto, onfulfilled?: (value: ExerciceDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Exercice/satisfaction";
        this.fetchApi<ExerciceDto>(url, MethodesFetch.POST, onfulfilled, onrejected, exercice);
    }

    public getMessage(typeMessage: string, numeroContrat: number, onfulfilled?: (value: MessageDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/Message/" + codeSociete + "/" + typeMessage + "/" + numeroContrat;
        this.fetchApi<MessageDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getMessages(typeMessage: string, numeroContrat: number, onfulfilled?: (value: MessageDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/Messages/" + codeSociete + "/" + typeMessage + "/" + numeroContrat;
        this.fetchApi<MessageDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public deleteMessage(id: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/Message/${id}`;
        this.fetchApi(url, MethodesFetch.DELETE, onfulfilled, onrejected, { id: id });
    }

    public getDernierExerciceCloture(onfulfilled?: (value: ExerciceDto) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/exercice/getdernierexercicecloture/${idSociete}`;
        this.fetchApi<ExerciceDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getDernierExercice(onfulfilled?: (value: ExerciceDto) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/exercice/getdernierexercice/${idSociete}`;
        this.fetchApi<ExerciceDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class VariablesHistoryService extends ServiceBase {
    public getExercices(onfulfilled?: (value: ExerciceHistoryDto[]) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/VariablesHistory/Exercices/" + idSociete;
        this.fetchApi<ExerciceHistoryDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetVariablesHistory(excerciceYear: number, excerciceMonth: number, onfulfilled?: (value: VariableHistoryDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/VariablesHistory/VariablesHistory/" + excerciceYear + "/" + excerciceMonth + "/" + codeSociete;
        this.fetchApi<VariableHistoryDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class CalculPaieService extends ServiceBase {
    public GetContratACalculer(onfulfilled?: (value: ContratACalculerDto[]) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/ContratACalculer/" + idSociete;
        this.fetchApi<ContratACalculerDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetContratAEditer(anneeDeb: number, moisDeb: number, anneeFin: number, moisFin: number, onfulfilled?: (value: ContratAEditerDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/ContratAEditer/${codeSociete}/${anneeDeb}/${moisDeb}/${anneeFin}/${moisFin}`;
        this.fetchApi<ContratAEditerDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetContratAReediter(anneeDeb: number, moisDeb: number, anneeFin: number, moisFin: number, onfulfilled?: (value: ContratAEditerDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/ContratAReediter/${codeSociete}/${anneeDeb}/${moisDeb}/${anneeFin}/${moisFin}`;
        this.fetchApi<ContratAEditerDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getBulletinsPdf(demande: DemandeEditionsPaieDto, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/GetBulletinsPdf";
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, demande);
    }

    public getBulletinsPdfParSalaries(demande: DemandeEditionsPaieParSalariesDto, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/GetBulletinsPdfParSalaries";
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, demande);
    }

    public calculerPayes(demande: DemandeCalculPaieDto, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/CalculerBulletin`;
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected, demande);
    }

    public getDetailCalculRubrique(idContrat: number, codeRubrique: string, onfulfilled?: (data: CalculPaieArretSurImageDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/DetailCalculRubrique/${idContrat}/${codeRubrique}`;
        this.fetchApi<CalculPaieArretSurImageDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public razPayes(demande: DemandeCalculPaieDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/RazBulletin`;
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected, demande);
    }

    public existeBulletinFinDeContratSurMoisEnCours(idContrat: number, onfulfilled?: (value: boolean) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/existebulletinfindecontratsurmoisencours/${idContrat}`;
        this.fetchApi<boolean>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public cloturerExercice(demande: DemandeCloturePaieDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/CloturerExercice";
        this.fetchApi<ExerciceDto[]>(url, MethodesFetch.POST, onfulfilled, onrejected, demande);
    }

    public devaliderclotureExercice(motDePasseSaisi: string, idExercice: number, onfulfilled?: (data: ExerciceDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/exercice/devaliderclotureexercice/${motDePasseSaisi}/${idExercice}`;
        this.fetchApi<ExerciceDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetBulletins(idSalarie: number, onfulfilled?: (value: BulletinHeaderDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/GetBulletins/${idSalarie}/${codeSociete}`;
        this.fetchApi<BulletinHeaderDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getBulletinMoisCourantPdf(idContat: number, onfulfilled?: (value: Blob) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/GetBulletinMoisCourant/" + idContat + "/pdf";
        this.fetchApiBlob(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetBulletin(idContat: number, annee: number, mois: number, onfulfilled?: (value: Blob) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/GetBulletin/" + idContat + "/" + annee + "/" + mois + "/pdf";
        this.fetchApiBlob(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public SendBulletin(idContrat: number, annee: number, mois: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/sendBulletin/${idContrat}/${annee}/${mois}`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public SendBulletinsDuMois(onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/SendBulletinsDuMois/${codeSociete}`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class AbsencesService extends ServiceBase {
    public GetAbsencesExcel(idExercice: number, onfulfilled?: (value: Blob) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/AbsencesExcel/" + idExercice;
        this.fetchApiBlob(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public exportAbsences(listTypeAbsence: CongesSalarieDto[], onfulfilled?: (value: Blob) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ExportAbsences/";
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, listTypeAbsence);
    }

    public getAbsencesHomeCalendar(currentMonth: number, currentYear: number, onfulfilled?: (value: CongesSalarieDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/absences/" + codeSociete + "/" + currentMonth + "/" + currentYear;
        this.fetchApi<CongesSalarieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public generationAttestationCrpcen(attestationDto: AttestationCrpcenDto, onfulfilled?: (value: Blob) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/AttestationCrpcen?codesociete=" + codeSociete;
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, attestationDto);
    }

    public getAttestationCrpcen(idAbsence: number, onfulfilled?: (value: AttestationCrpcenDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/AttestationCrpcen/${idAbsence}`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetCongeAdministrateur(currentYear: number, currentMonth: number, onfulfilled?: (value: CongesSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/GetCongeAdministrateur/" + codeSociete + "/" + currentYear + "/" + currentMonth;
        this.fetchApi<CongesSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetCongeSalarie(currentYear: number, currentMonth: number, idSalarie: number, onfulfilled?: (value: CongesSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/GetCongeSalarie/" + codeSociete + "/" + currentYear + "/" + currentMonth + "/" + idSalarie;
        this.fetchApi<CongesSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetAbsenceUtilisateurValideurConges(currentYear: number, currentMonth: number, idUtilisateurValideurConges: number, onfulfilled?: (value: CongesSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/GetAbsenceUtilisateurValideurConges/" + codeSociete + "/" + currentYear + "/" + currentMonth + "/" + idUtilisateurValideurConges;
        this.fetchApi<CongesSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getAbsences(currentMonth: number, currentYear: number, onfulfilled?: (value: CongesSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/absences/" + codeSociete + "/" + currentMonth + "/" + currentYear;
        this.fetchApi<CongesSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getAbsence(id: number, onfulfilled?: (value: AbsenceSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Absence/" + id;
        this.fetchApi<AbsenceSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public annulerAbsenceCollective(ids: number[], envoyerEMailSalaries: boolean, onfulfilled?: (value: string[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/AbsenceCollective?envoyerEMailSalaries=${envoyerEMailSalaries}`;
        this.fetchApi<string[]>(url, MethodesFetch.DELETE, onfulfilled, onrejected, ids);
    }

    public getAbsencesSalarieImposees(onfulfilled?: (value: AbsenceSalarieDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/AbsencesSalarieImposees" + "?codeSociete=" + codeSociete;
        this.fetchApi<AbsenceSalarieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getAbsencesSalarieConnecte(onfulfilled?: (value: AbsenceSalarieDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/AbsencesSalarie?codeSociete=" + codeSociete;
        this.fetchApi<AbsenceSalarieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getAbsencesEnAttenteDeValidation(onfulfilled?: (value: AbsenceSalarieDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/absencesEnAttente";
        this.fetchApi<AbsenceSalarieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetCongesDoubleCalendrier(idSalarie: number, currentMonth: number, currentYear: number, onfulfilled?: (value: CongeDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/GetCongesDoubleCalendrier/" + idSalarie + "/" + currentMonth + "/" + currentYear + "?codeSociete=" + codeSociete;
        this.fetchApi<CongeDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public EnregistrerAbsenceCollective(absences: AbsenceSalarieDto[], envoyerEMailSalaries: boolean, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        for (let i = 0; i < absences.length; i++) {
            absences[i].CodeSociete = codeSociete;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/EnregistrerAbsenceCollective?envoyerEMailSalaries=${envoyerEMailSalaries}`;
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected, absences);
    }

    public enregistrerAbsence(absence: AbsenceSalarieDto, isActionSalarie: boolean, envoyerEMailSalarie: boolean, onfulfilled?: (value: AbsenceSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/enregistrerabsence?isActionSalarie=${isActionSalarie}&envoyerEMailSalarie=${envoyerEMailSalarie}`;
        this.fetchApi<AbsenceSalarieDto>(url, MethodesFetch.POST, onfulfilled, onrejected, absence);
    }

    public changerEtatAbsence(commande: CommandeChangementEtatAbsenceDto, envoyerEMailSalarie: boolean, onfulfilled?: (value: AbsenceSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/changeretatabsence?envoyeremailsalarie=${envoyerEMailSalarie}`;
        this.fetchApi<AbsenceSalarieDto>(url, MethodesFetch.POST, onfulfilled, onrejected, commande);
    }

    public getEnregistrementAbsence(commande: CommandeEnregistrementAbsenceDto, onfulfilled?: (value: EnregistrementAbsenceDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/enregistrementabsence/`;
        this.fetchApi<EnregistrementAbsenceDto>(url, MethodesFetch.POST, onfulfilled, onrejected, commande);
    }

    public annulerAbsencesFuturesFinDeContrat(idContrat: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/AnnulerAbsencesFuturesFinDeContrat/${idContrat}`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getAbsencesFuturesByContrat(demandeRecuperationAbsencesFutures: DemandeRecuperationAbsencesFuturesDto, onfulfilled?: (value: AbsenceClotureCreationContratDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/GetAbsencesFuturesByContrat`;
        this.fetchApi<AbsenceClotureCreationContratDto[]>(url, MethodesFetch.PUT, onfulfilled, onrejected, demandeRecuperationAbsencesFutures);
    }

    public transfererAbsences(demandeTransfertAbsenceDto: DemandeTransfertAbsenceDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/TransfererAbsencesFuturesFinDeContrat`;
        this.fetchApi(url, MethodesFetch.PUT, onfulfilled, onrejected, demandeTransfertAbsenceDto);
    }
}

export class PstService extends ServiceBase {
    public SoumettreSaisie(onfulfilled?: (etat: EtatSaisie) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SoumettreSaisie/" + idSociete;
        this.fetchApi<EtatSaisie>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public ValiderSaisie(onfulfilled?: (etat: EtatSaisie) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/ValiderSaisie/" + idSociete;
        this.fetchApi<EtatSaisie>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class SocieteService extends ServiceBase {
    public create(command: SocieteCreationCommandDto, onfulfilled?: (societe: SocieteDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/Societe?codeSociete=" + codeSociete;
        this.fetchApi<SocieteDto>(url, MethodesFetch.POST, onfulfilled, onrejected, command);
    }

    public getSocieteAdministratif(code: string, onfulfilled?: (value: SocieteAdministratifDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Societe/Administratif/" + code;
        this.fetchApi<SocieteAdministratifDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateSocieteAdministratif(societe: SocieteAdministratifDto, onfulfilled?: (codeSociete: string) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Societe/Administratif/";
        this.fetchApi<string>(url, MethodesFetch.PUT, onfulfilled, onrejected, societe);
    }

    public getSocieteParametrage(code: string, onfulfilled?: (value: SocieteParametrageDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Societe/Parametrage/" + code;
        this.fetchApi<SocieteParametrageDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateSocieteParametrage(societe: SocieteParametrageDto, onfulfilled?: (activite: SocieteParametrageDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Societe/Parametrage/";
        this.fetchApi<SocieteParametrageDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, societe);
    }

    public getSocieteReglements(code: string, onfulfilled?: (value: SocieteReglementsDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Societe/Reglements/" + code;
        this.fetchApi<SocieteReglementsDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateSocieteReglements(societe: SocieteReglementsDto, onfulfilled?: (activite: SocieteReglementsDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Societe/Reglements/";
        this.fetchApi<SocieteReglementsDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, societe);
    }

    public updateSocieteReglement(reglement: ReglementTypeDto, onfulfilled?: (value: ReglementTypeDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/Societe/Reglement/`;
        this.fetchApi<ReglementTypeDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, reglement);
    }

    public getSocieteDsn(code: string, onfulfilled?: (value: SocieteDsnDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Societe/Dsn/" + code;
        this.fetchApi<SocieteDsnDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateSocieteDsn(societe: SocieteDsnDto, onfulfilled?: (activite: SocieteDsnDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Societe/Dsn/";
        this.fetchApi<SocieteDsnDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, societe);
    }

    public updateSocietesStatut(societes: SocieteDto[], onfulfilled?: (societes: SocieteDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/UpdateSocietesStatut`;
        this.fetchApi<SocieteDto[]>(url, MethodesFetch.PUT, onfulfilled, onrejected, societes);
    }

    public getAllSocietes(onfulfilled?: (societes: SocieteDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/Societes`;
        this.fetchApi<SocieteDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSocietesActivesOfSalarieConnecte(onfulfilled?: (value: SocieteDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/SocietesActivesOfSalarieConnecte`;
        this.fetchApi<SocieteDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class UtilisateursService extends ServiceBase {
    public getUtilisateurs(onfulfilled?: (value: UtilisateurLightDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/utilisateurs";
        this.fetchApi<UtilisateurLightDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getUtilisateursWithRolesTalent(onfulfilled?: (value: UtilisateurSSORolesTalent[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/utilisateurs/WithRolesTalent";
        this.fetchApi<UtilisateurSSORolesTalent[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class UtilisateurService extends ServiceBase {
    public getUtilisateurById(Id: number, onfulfilled?: (value: UtilisateurSsoDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/utilisateur/" + Id;
        this.fetchApi<UtilisateurSsoDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateUtilisateur(utilisateur: UtilisateurSsoDto, onfulfilled?: (value: UtilisateurSsoDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/utilisateur/";
        this.fetchApi<UtilisateurSsoDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, utilisateur);
    }

    public AddUtilisateur(utilisateur: UtilisateurSsoDto, onfulfilled?: (value: UtilisateurSsoDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/utilisateur/";
        this.fetchApi<UtilisateurSsoDto>(url, MethodesFetch.POST, onfulfilled, onrejected, utilisateur);
    }

    public updateProfil(profil: ProfilUtilisateurDto, onfulfilled?: (value: ProfilUtilisateurDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/profilUtilisateur";
        this.fetchApi<ProfilUtilisateurDto>(url, MethodesFetch.POST, onfulfilled, onrejected, profil);
    }
}

export class GestionDesAbsencesService extends ServiceBase {
    public getSalarieConnecteInfos(onfulfilled?: (value: SalarieConnecteDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SalarieConnecte?codeSociete=" + codeSociete;
        this.fetchApi<StatuAbsenceSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class StatuAbsenceService extends ServiceBase {
    public getSalarieById(idSalarie: number, onfulfilled?: (value: StatuAbsenceSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/StatuAbsenceSalarie/" + idSalarie + "?codeSociete=" + codeSociete;
        this.fetchApi<StatuAbsenceSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getEquipe(onfulfilled?: (value: StatuAbsenceSalarieDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/StatuAbsenceEquipe?codeSociete=" + codeSociete;
        this.fetchApi<StatuAbsenceSalarieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public enregistrerValideurConges(valideurConges: ValideurCongesDto, onfulfilled?: (value: ValideurCongesDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/enregistrervalideurconges`;
        this.fetchApi<ValideurCongesDto>(url, MethodesFetch.POST, onfulfilled, onrejected, valideurConges);
    }

    public deleteValideurConges(id: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/deletevalideurconges/${id}`;
        this.fetchApi(url, MethodesFetch.DELETE, onfulfilled, onrejected, id);
    }

    public getListeValideursConges(idSalarie: number, onfulfilled?: (value: ValideurCongesDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/listevalideursconges/${idSalarie}`;
        this.fetchApi<ValideurCongesDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class SignalRService extends ServiceBase {
    public connection: any
    public hub: any

    public connect(): void {
        this.connection = $.hubConnection(ServicesFactoryInstance.urlBase + "/signalr");
        this.hub = this.connection.createHubProxy("MainHub");
        this.hub.logging = true;

        this.hub.on("message", function (message) {
            console.warn("Message SignalR");
            console.warn(message);
            EventBus.$emit(message.MessageType, message.Message);
        });

        //  Demarrage de SignalR
        const self = this;
        this.connection.qs = { access_token: ServicesFactoryInstance.TokenAuthentication.token };
        this.connection.start({ jsonp: true, credentials: "test" })
            .done(function () {
                console.warn("Now connected, connection ID=" + self.connection.id);
            })
            .fail(function () {
                console.warn("Could not connect");
            });
        this.connection.reconnecting(() => {
            console.warn("reconnecting");
        });
        this.connection.reconnected(() => {
            console.warn("reconnected");
        });
        this.connection.disconnected(() => {
            console.warn("disconnected");
        });
    }
}

export class EntreeSalarieService extends ServiceBase {
    public getEntreesSalarie(onfulfilled?: (value: EntreeSalarieDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/EntreesSalarie?codeSociete=" + codeSociete;
        this.fetchApi<EntreeSalarieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getEntreeSalarie(id: number, onfulfilled?: (value: EntreeSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/EntreeSalarie?id=" + id;
        this.fetchApi<EntreeSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getEntreeSalarieFromFicheSalarie(idSalarie: number, onfulfilled?: (value: EntreeSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/EntreeSalarie?codeSociete=${codeSociete}&idSalarie=${idSalarie}`;
        this.fetchApi<EntreeSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public addEntreeSalarie(entree: EntreeSalarieDto, onfulfilled?: (data: EntreeSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/EntreeSalarie";
        this.fetchApi<EntreeSalarieDto>(url, MethodesFetch.POST, onfulfilled, onrejected, entree);
    }

    public updateEntreeSalarie(entree: EntreeSalarieDto, onfulfilled?: (value: EntreeSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/EntreeSalarie/";
        this.fetchApi<EntreeSalarieDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, entree);
    }

    public soumettreAValidation(id: number, onfulfilled?: (value: EntreeSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/soumettreAValidation?codeSociete=" + codeSociete + "&id=" + id;
        this.fetchApi<EntreeSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public valideEmployeEntry(id: number, onfulfilled?: (data: number) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/ValideEmployeEntry?codeSociete=" + codeSociete + "&id=" + id;
        this.fetchApi<number>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public deleteEntreeSalarie(id: number, onfulfilled?: (value: number) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/DeleteEntreeSalarie?codeSociete=" + codeSociete + "&id=" + id;
        this.fetchApi<number>(url, MethodesFetch.DELETE, onfulfilled, onrejected, id);
    }

    public getListePropositionsEntreeSalarie(onfulfilled?: (value: PropositionEntreeSalarieDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/ListePropositionsEntreeSalarie`;
        this.fetchApi<PropositionEntreeSalarieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class SortieSalarieService extends ServiceBase {
    public getSortiesSalarie(onfulfilled?: (value: SortieSalarieDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SortiesSalarie?codeSociete=" + codeSociete;
        this.fetchApi<SortieSalarieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getSortieSalarie(id: number, onfulfilled?: (value: SortieSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/SortieSalarie?id=" + id;
        this.fetchApi<SortieSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public addSortieSalarie(sortie: SortieSalarieDto, onfulfilled?: (data: SortieSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/SortieSalarie";
        this.fetchApi<SortieSalarieDto>(url, MethodesFetch.POST, onfulfilled, onrejected, sortie);
    }

    public updateSortieSalarie(sortie: SortieSalarieDto, onfulfilled?: (value: SortieSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/SortieSalarie/";
        this.fetchApi<SortieSalarieDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, sortie);
    }

    public soumettreAValidation(id: number, onfulfilled?: (value: SortieSalarieDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SoumettreAValidationSortie?codeSociete=" + codeSociete + "&id=" + id;
        this.fetchApi<SortieSalarieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public valideEmployeExit(id: number, onfulfilled?: (data: SalarieContratIdsDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/ValideEmployeExit?codeSociete=${codeSociete}&id=${id}`;
        this.fetchApi<SalarieContratIdsDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public deleteSortieSalarie(id: number, onfulfilled?: (value: number) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/SortieSalarie?codeSociete=" + codeSociete + "&id=" + id;
        this.fetchApi<number>(url, MethodesFetch.DELETE, onfulfilled, onrejected, id);
    }
}

export class DsnService extends ServiceBase {
    public getListeDsnMetadata(nature: DsnNatureDeclaration, annee: number, onfulfilled?: (value: DsnHeaderDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/dsn/liste/" + codeSociete + "/" + nature + "/" + annee;
        this.fetchApi<DsnHeaderDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getFilterParameters(nature: DsnNatureDeclaration, onfulfilled?: (value: DsnFilterParametersDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/dsn/filter/" + codeSociete + "/" + nature;
        this.fetchApi<DsnFilterParametersDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getFirstDsnYear(nature: DsnNatureDeclaration, onfulfilled?: (value: number) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/dsn/GetFirstDsnYear/" + codeSociete + "/" + nature;
        this.fetchApi<number>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public envoyerDepot(idDsnMetadata: number, integreOeth: boolean, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/dsn/depot/" + idDsnMetadata + "/" + integreOeth;
        this.fetchApi<DsnHeaderDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public envoyerDepotManuel(dsnMetadata: DsnManuelleDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/dsn/depotmanuel/`;
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected, dsnMetadata);
    }

    public rafraichir(idDsnMetadata: number, onfulfilled?: (value: DsnHeaderDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/dsn/rafraichir/" + idDsnMetadata;
        this.fetchApi<DsnHeaderDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getDsnDto(idDsnMetadata: number, integreOeth: boolean, onfulfilled?: (value: DsnManuelleDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/dsn/dsnManuelle/" + idDsnMetadata + "/" + integreOeth;
        this.fetchApi<DsnManuelleDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public recupererCompteRendu(idDsnMetadata: number, onfulfilled?: (value: DsnCompteRenduDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/dsn/recuperercompterendu/" + idDsnMetadata;
        this.fetchApi<DsnCompteRenduDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public recupererDocumentGed(codeDocumentGed: string, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/dsn/recupererdocumentged/${codeDocumentGed}`;
        this.fetchApiBlob(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetDsnDeclarationDetaillee(idDsnMetadata: number, onfulfilled?: (value: DsnDeclarationDetailleeDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/dsn/getdsndeclarationdetaillee?idDsnMetadata=${idDsnMetadata}`;
        this.fetchApi<DsnDeclarationDetailleeDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getListeEffectifs(annee: number, onfulfilled?: (value: NeoresEffectifDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/dsn/listeeffectifs/${codeSociete}/${annee}`;
        this.fetchApi<NeoresEffectifDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public supprimerDsnMetadata(idDsnMetadata: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/dsn/supprimer/${idDsnMetadata}`;
        this.fetchApi(url, MethodesFetch.DELETE, onfulfilled, onrejected);
    }
}

export class DpaeService extends ServiceBase {
    public getLignesEtRafraichitDemandesDpae(onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/GetLignesEtRafraichitDemandesDpae/${codeSociete}`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getDemandeDpaeFromContrat(idContrat: number, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/GetDemandeDpaeFromContrat?idContrat=${idContrat}&codeSociete=${codeSociete}`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getDemandeDpaeFromHistorique(idDemandeHistorique: number, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/GetDemandeDpaeFromHistorique?idDemandeHistorique=${idDemandeHistorique}`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public creerEtDeposerDemandeDpae(demande: DemandeDpaeDto, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/CreerEtDeposerDemandeDpae`;
        this.fetchApi<DemandeDpaeDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, demande);
    }

    public updateMdpDpae(infosModif: ModificationMdpUrssafDto, onfulfilled?: (codeSociete: string) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/Societe/UpdateMdpDpae`;
        this.fetchApi<string>(url, MethodesFetch.PUT, onfulfilled, onrejected, infosModif);
    }

    public getDemandeErreurs(idDemande: number, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/GetDpaeErreurs/${codeSociete}/${idDemande}`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public genereAttestationDpae(idDemande: number, onfulfilled?: (r) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/GenereAttestationDpae/${idDemande}`;
        this.fetchApiBlob(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class ParametragesModuleService extends ServiceBase {
    public getParametragesModule(onfulfilled?: (value: ParametreModuleDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ParametragesModule/";
        this.fetchApi<ParametreModuleDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getModules(onfulfilled?: (value: string[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Modules/";
        this.fetchApi<string[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class ParametrageModuleService extends ServiceBase {
    public getParametrageModuleById(id: number, onfulfilled?: (value: ParametreModuleDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ParametrageModuleById/" + id;
        this.fetchApi<ParametreModuleDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getParametrageModule(module: ParametrageModuleEnum, id: ParametrageModuleIdEnum, onfulfilled?: (value: ParametreModuleDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ParametrageModule/" + module + "/" + id;
        this.fetchApi<ParametreModuleDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updateParametrageModule(parametrage: ParametreModuleDto, onfulfilled?: (value: ParametreModuleDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ParametrageModule/";
        this.fetchApi<ParametreModuleDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, parametrage);
    }

    public debloquerTraitementEnCours(onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/DebloquerTraitementEnCours`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

// Correspond à l'ancienne API de déclaration taux PAS
export class TopazeService extends ServiceBase {
    public updateSalariesTauxPas(demande: DemandeImportTopazeDto, onfulfilled?: (value: number[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/topaze/UpdateSalariesTauxPas";
        this.fetchApi<number[]>(url, MethodesFetch.PUT, onfulfilled, onrejected, demande);
    }

    public getSalariesFromXMLFile(demandeImportTopaze: DemandeImportTopazeDto, onfulfilled?: (value: SalarieTopazeDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        demandeImportTopaze.CodeSociete = codeSociete;

        const url = ServicesFactoryInstance.urlBase + "/api/topaze/GetSalariesFromXMLFile";
        this.fetchApi<SalarieTopazeDto[]>(url, MethodesFetch.POST, onfulfilled, onrejected, demandeImportTopaze);
    }
}

// Correspond à la nouvelle API de l'amorçage du taux PAS
export class AmorcageTauxPASService extends ServiceBase {
    public SaveAmorcageTauxPASByContrat(idContrat: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/SaveAmorcageTauxPASByContrat/${idContrat}`;
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected);
    }

    public GetAmorcagesContratsTauxPAS(annee: number, onfulfilled?: (value: AmorcageContratTauxPASDto[]) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }
        const url = `${ServicesFactoryInstance.urlBase}/api/GetAmorcagesContratsTauxPAS/${codeSociete}/${annee}`;
        this.fetchApi(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public mettreAJourTauxPAS(idDsnMetadata: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/dsnamorcage/majtauxpas/${idDsnMetadata}`;
        this.fetchApi(url, MethodesFetch.PUT, onfulfilled, onrejected);
    }
}

export class ContratAutoFromDsnService extends ServiceBase {
    public PutFichierDsn(demande: ContratAutoFromDsnDto, onfulfilled?: (value: ImportDsnAutoDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/FromDto";
        this.fetchApi<ImportDsnAutoDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, demande);
    }

    public CreateFromImportDsn(importDsn: ImportDsnAutoDto, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/CreateFromImportDsn?CodeSociete=${codeSociete}`;
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected, importDsn);
    }
}

export class JoursFeriesService extends ServiceBase {
    public async getJoursFeries(onfulfilled?: (value: JourFerieDto[]) => void, onrejected?: (reason: any) => void): Promise<void> {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = ServicesFactoryInstance.urlBase + "/api/joursFeries?idSociete=" + idSociete;
        return this.fetchApi<JourFerieDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getJourFerieById(id: number, onfulfilled?: (value: JourFerieDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/joursFeries/" + id;
        this.fetchApi<JourFerieDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public addJourFerie(jourFerie: JourFerieDto, onfulfilled?: (value: JourFerieDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/joursFeries";
        this.fetchApi<JourFerieDto>(url, MethodesFetch.POST, onfulfilled, onrejected, jourFerie);
    }

    public updateJourFerie(jourFerie: JourFerieDto, onfulfilled?: (value: JourFerieDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/joursFeries";
        this.fetchApi<JourFerieDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, jourFerie);
    }

    public deleteJourFerie(id: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/joursFeries/${id}`;
        this.fetchApi(url, MethodesFetch.DELETE, onfulfilled, onrejected, id);
    }
}

export class HealthCheckService extends ServiceBase {
    public getServicesStatus(onfulfilled?: (value: ServiceStatusDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/check/Health/ServicesStatus";
        this.fetchApi<ServiceStatusDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getVersion(onfulfilled?: (value: string) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/check/Health/Version";
        this.fetchApi<string>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class DeclarationOethService extends ServiceBase {
    public GetListeDeclarationsOeth(estIncluseDeclarationACreer: boolean, onfulfilled?: (value: DeclarationOethDto[]) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/declarationoeth/getlistedeclarationsoeth/${idSociete}/${estIncluseDeclarationACreer}`;
        this.fetchApi<DeclarationOethDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetDeclarationOethCalculee(id: number, onfulfilled?: (value: DeclarationOethCalculeeDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/declarationoeth/getdeclarationoethcalculee/${id}`;
        this.fetchApi<DeclarationOethCalculeeDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public CreeDeclarationOeth(declarationOeth: DeclarationOethDto, onfulfilled?: (value: DeclarationOethDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/declarationoeth/creedeclarationoeth/`;
        this.fetchApi<DeclarationOethDto>(url, MethodesFetch.POST, onfulfilled, onrejected, declarationOeth);
    }

    public ModifieDeclarationOeth(declarationOeth: DeclarationOethDto, onfulfilled?: (value: DeclarationOethDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/declarationoeth/modifiedeclarationoeth/`;
        this.fetchApi<DeclarationOethDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, declarationOeth);
    }

    public PrepareDeclarationsOeth(id: number, onfulfilled?: (value: DeclarationOethDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/declarationoeth/preparedeclarationoeth/${id}`;
        this.fetchApi<DeclarationOethDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class VirementService extends ServiceBase {
    public GetFichierVirementsSepa(demande: DemandeFichierVirementsSepaDto, onfulfilled?: (value: Blob) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/virement/getfichiervirementssepa`;
        this.fetchApiBlob(url, MethodesFetch.POST, onfulfilled, onrejected, demande);
    }
}

export class CompteurAbsenceService extends ServiceBase {
    public getFicheSalarieAbsence(idSalarie: number, onfulfilled?: (value: FicheSalarieAbsenceDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/FicheSalarieAbsence/${codeSociete}/${idSalarie}/`;
        this.fetchApi<FicheSalarieAbsenceDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public GetStatuAbsence(onfulfilled?: (value: StatuAbsenceDto) => void, onrejected?: (reason: any) => void): void {
        const codeSociete = this.getCodeSociete(onrejected);
        if (codeSociete == "") {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/api/statuabsence/${codeSociete}`;
        this.fetchApi<StatuAbsenceDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class HoraireHebdoService extends ServiceBase {
    private urlContrat = "api/HoraireHebdo/Contrat";
    private urlEntree = "api/HoraireHebdo/EntreeSalarie";

    public getHoraireHebdoContrat(idContrat: number, onfulfilled?: (value: HoraireHebdoDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/${this.urlContrat}/${idContrat}`;
        this.fetchApi<HoraireHebdoDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getHoraireHebdoEntreeSalarie(idEntreeSalarie: number, onfulfilled?: (value: HoraireHebdoDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/${this.urlEntree}/${idEntreeSalarie}`;
        this.fetchApi<HoraireHebdoDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public addOrUpdateHoraireHebdoContrat(idContrat: number, horaireHebdo: HoraireHebdoDto, onfulfilled?: (HoraireHebdoUpdated: HoraireHebdoDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/${this.urlContrat}/${idContrat}`;
        this.fetchApi<HoraireHebdoDto>(url, MethodesFetch.POST, onfulfilled, onrejected, horaireHebdo);
    }

    public addOrUpdateHoraireHebdoEntreeSalarie(idEntreeSalarie: number, horaireHebdo: HoraireHebdoDto, onfulfilled?: (HoraireHebdoUpdated: HoraireHebdoDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/${this.urlEntree}/${idEntreeSalarie}`;
        this.fetchApi<HoraireHebdoDto>(url, MethodesFetch.POST, onfulfilled, onrejected, horaireHebdo);
    }
}

export class ModelRequeteService extends ServiceBase {
    public initModels(onfulfilled?: (value: ModelRequeteDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/modelrequetes";
        this.fetchApi<ModelRequeteDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getModel(id: number, onfulfilled?: (value: ModelRequeteDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/modelrequete?id=" + id;
        this.fetchApi<ModelRequeteDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public addModel(model: ModelRequeteDto, onfulfilled?: (value: ModelRequeteDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/modelrequete";
        this.fetchApi<ModelRequeteDto>(url, MethodesFetch.POST, onfulfilled, onrejected, model);
    }

    public updateModel(model: ModelRequeteDto, onfulfilled?: (value: ModelRequeteDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/modelrequete";
        this.fetchApi<ModelRequeteDto>(url, MethodesFetch.PUT, onfulfilled, onrejected, model);
    }
}

export class RequeteurService extends ServiceBase {
    public getDataId(id: number, onfulfilled?: (value: RequeteurDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Requeteur?id=" + id;
        this.fetchApi<RequeteurDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public getData(model: ModelRequeteDto, onfulfilled?: (value: RequeteurDto) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/Requeteur";
        this.fetchApi<RequeteurDto>(url, MethodesFetch.POST, onfulfilled, onrejected, model);
    }

    public exportDataId(id: number, onfulfilled?: (value: Blob) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ExportRequeteur?id=" + id;
        this.fetchApiBlob(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class LicensingService extends ServiceBase {
    private urlLicensingTalent = "api/Licensing";

    public getLicensesActive(numeroIcare: number, onfulfilled?: (value: string[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/${this.urlLicensingTalent}/${numeroIcare}`;
        this.fetchApi<string[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class PrimoboxService extends ServiceBase {
    private urlPrimobox = "api/Primobox";

    public getPrimoboxExercices(onfulfilled?: (value: PrimoboxExerciceDto[]) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/${this.urlPrimobox}/GetExercices/${idSociete}`;
        this.fetchApi<PrimoboxExerciceDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public distributeBulletins(idexercice: number, onfulfilled?: (value: PrimoboxExerciceDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/${this.urlPrimobox}/Distribuer/${idexercice}`;
        this.fetchApi<PrimoboxExerciceDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public redistributeBulletins(idexercice: number, IdContrats: number[], onfulfilled?: (value: PrimoboxExerciceDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/${this.urlPrimobox}/Redistribuer/${idexercice}`;
        this.fetchApi<PrimoboxExerciceDto>(url, MethodesFetch.POST, onfulfilled, onrejected, IdContrats);
    }

    public validerDistribution(idTraitement: number, onfulfilled?: (value: PrimoboxExerciceDto) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/${this.urlPrimobox}/Valider/${idTraitement}`;
        this.fetchApi<PrimoboxExerciceDto>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public updatePrimoboxExercices(idExercice?: number, onfulfilled?: (value: boolean) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/${this.urlPrimobox}/UpdateExercices/${idSociete}/${idExercice}`;
        this.fetchApi<boolean>(url, MethodesFetch.PUT, onfulfilled, onrejected, null);
    }

    public synchronizePrimoboxSalaries(IdContrats: number[], onfulfilled?: (value: boolean) => void, onrejected?: (reason: any) => void): void {
        const idSociete = this.getIdSociete(onrejected);
        if (idSociete == 0) {
            return;
        }

        const url = `${ServicesFactoryInstance.urlBase}/${this.urlPrimobox}/SynchronizePrimoboxSalaries/${idSociete}`;
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected, IdContrats);
    }

    public getPrimoboxTraitementDetails(idexercice: number, onfulfilled?: (value: PrimoboxTraitementDetailDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/${this.urlPrimobox}/Details/${idexercice}`;
        this.fetchApi<PrimoboxTraitementDetailDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class RegleSequenceCalculService extends ServiceBase {
    public async getListeReglesSequencesCalculAsync(onfulfilled?: (value: RegleSequenceCalculDto[]) => void, onrejected?: (reason: any) => void): Promise<void> {
        const url = `${ServicesFactoryInstance.urlBase}/api/reglesequencecalcul/liste`;
        await this.fetchApi<RegleSequenceCalculDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }
}

export class EntiteAttenteTransfertService extends ServiceBase {
    public getListeTransfertSql(onfulfilled?: (value: EntiteAttenteTransfertDto[]) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/ListeAttenteTransfert`;
        this.fetchApi<EntiteAttenteTransfertDto[]>(url, MethodesFetch.GET, onfulfilled, onrejected);
    }

    public addRubriqueToList(idRubrique: number, onfulfilled?: (value: void) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ListeAttenteTransfert/Rubrique";
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected, idRubrique);
    }

    public addParametreToList(demande: DemandeParamTransfertDto, onfulfilled?: (value: void) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/ListeAttenteTransfert/Parametre`;
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected, demande);
    }

    public addTableauToList(idTableau: number, onfulfilled?: (value: void) => void, onrejected?: (reason: any) => void): void {
        const url = `${ServicesFactoryInstance.urlBase}/api/ListeAttenteTransfert/Tableau`;
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected, idTableau);
    }

    public transmettreListeEntites(listeElements: EntiteAttenteTransfertDto[], onfulfilled?: (value: void) => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ListeAttenteTransfert/Transmettre";
        this.fetchApi(url, MethodesFetch.POST, onfulfilled, onrejected, listeElements);
    }

    public deleteElementListeTransfertSql(idElementTransfertSql: number, onfulfilled?: () => void, onrejected?: (reason: any) => void): void {
        const url = ServicesFactoryInstance.urlBase + "/api/ListeAttenteTransfert/" + idElementTransfertSql;
        this.fetchApi<number>(url, MethodesFetch.DELETE, onfulfilled, onrejected, idElementTransfertSql);
    }
}

export interface TokenAuthentication {
    token: string;
    userName: string;
}

export class ServicesFactory {
    public urlBase = ""

    public AuthenticationService: AuthenticationService = new AuthenticationService();
    public HeaderService: HeaderService = new HeaderService();
    public AccueilService: AccueilService = new AccueilService();
    public CalculPaieService: CalculPaieService = new CalculPaieService();
    public CommunesService: CommunesService = new CommunesService();
    public ParametreService: ParametreService = new ParametreService();
    public ParametresService: ParametresService = new ParametresService();
    public SalarieService: SalarieService = new SalarieService();
    public GedService: GedService = new GedService();
    public AideEnLigneService: AideEnLigneService = new AideEnLigneService();
    public VariablesService: VariablesService = new VariablesService();
    public VariableCsvService: VariableCsvService = new VariableCsvService();
    public ConfigurationEtude: ConfigurationEtudeService = new ConfigurationEtudeService();
    public RubriquesService: RubriquesService = new RubriquesService();
    public EditionsService: EditionsService = new EditionsService();
    public RubriqueService: RubriqueService = new RubriqueService();
    public ScenariosService: ScenariosService = new ScenariosService();
    public AbsencesService: AbsencesService = new AbsencesService();
    public StatuAbsenceService: StatuAbsenceService = new StatuAbsenceService();
    public ExercicesService: ExercicesService = new ExercicesService();
    public GestionDesAbsencesService: GestionDesAbsencesService = new GestionDesAbsencesService();
    public SocieteService: SocieteService = new SocieteService();
    public UtilisateurService: UtilisateurService = new UtilisateurService();
    public UtilisateursService: UtilisateursService = new UtilisateursService();
    public SignalRService: SignalRService = new SignalRService();
    public EntreeSalarieService: EntreeSalarieService = new EntreeSalarieService();
    public SortieSalarieService: SortieSalarieService = new SortieSalarieService();
    public PstService: PstService = new PstService();
    public DsnService: DsnService = new DsnService();
    public DpaeService: DpaeService = new DpaeService();
    public ContratAutoFromDsnService: ContratAutoFromDsnService = new ContratAutoFromDsnService();
    public HealthCheckService: HealthCheckService = new HealthCheckService();
    public ParametragesModuleService: ParametragesModuleService = new ParametragesModuleService();
    public ParametrageModuleService: ParametrageModuleService = new ParametrageModuleService();
    public ParametreSpecifiqueService: ParametreSpecifiqueService = new ParametreSpecifiqueService();
    public UtilisateurExterneService: UtilisateurExterneService = new UtilisateurExterneService();
    public TopazeService: TopazeService = new TopazeService();
    public AmorcageTauxPASService: AmorcageTauxPASService = new AmorcageTauxPASService();
    public JoursFeriesService: JoursFeriesService = new JoursFeriesService();
    public VariablesHistoryService: VariablesHistoryService = new VariablesHistoryService();
    public OrganismeService: OrganismeService = new OrganismeService();
    public DeclarationOethService: DeclarationOethService = new DeclarationOethService();
    public VirementService: VirementService = new VirementService();
    public HoraireHebdoService: HoraireHebdoService = new HoraireHebdoService();
    public ModelRequeteService: ModelRequeteService = new ModelRequeteService();
    public RequeteurService: RequeteurService = new RequeteurService();
    public CompteurAbsenceService: CompteurAbsenceService = new CompteurAbsenceService();
    public LicensingService: LicensingService = new LicensingService();
    public PrimoboxService: PrimoboxService = new PrimoboxService();
    public RegleSequenceCalculService: RegleSequenceCalculService = new RegleSequenceCalculService();
    public EntiteEnAttenteService: EntiteAttenteTransfertService = new EntiteAttenteTransfertService();

    public TokenAuthentication: TokenAuthentication = { token: "", userName: "" };

    public constructor() {
        if (ParametresInstance != undefined) {
            ParametresInstance.refreshAllList();
        }
    }
}

export const ServicesFactoryInstance: ServicesFactory = new ServicesFactory();




// WEBPACK FOOTER //
// ./src/components/Controls/ServicesFactory.ts